<div class="container-fluid">
  <div class="row">
    <div
      class="col-12 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-2">
      <div class="d-flex page-title-box">
        <h4 class="mb-0">Department</h4>
        &nbsp;&nbsp;
        <p class="mb-0">PlantDashboard > Department</p>
      </div>
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <div *ngIf="machine_List?.length">LUT: {{ lut }}</div>
        &nbsp;
        <div *ngIf="departmentData.length != 0" (click)="refresh('ui')"
          class="d-flex align-items-center px-2 py-1 text-white" style="
            background-color: #007d79;
            cursor: pointer;
            border-radius: 5px;
            height: 30px;
            transition: background-color 0.3s ease;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
          ">
          <i class="ri-refresh-line me-1" title="Refresh"></i> Refresh
        </div>
        &nbsp;
        <div *ngIf="role === 'CUSTOMER'" (click)="backbtn()" class="btn btn-primary d-flex align-items-center px-2 py-1"
          style="
            height: 30px;
            border-radius: 5px;
            transition: background-color 0.3s ease;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
          ">
          <i class="ri-arrow-left-fill me-1" title="Back"></i> Back
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="departmentData.length == 0">
    <h5>No Departments are Mapped for this User, Contact Admin.</h5>
  </div>
  <div class="row" *ngIf="departmentData.length != 0">
    <div class="col-md-3">
      <label for="department">Select Department</label>
      <select class="form-control" name="department" id="department" [(ngModel)]="selectedDepartment"
        (change)="changeDepartment($event)" style="color: black">
        <option [value]="data.departmentName" *ngFor="let data of departmentData">
          {{ data.departmentName }}
        </option>
      </select>
    </div>
  </div>
  <div class="row mt-1" *ngIf="departmentData.length != 0">
    <div class="col-md-6">
      <div class="card">
        <div class="card-header" style="background-color: #0e7d79">
          <div style="display: flex; justify-content: space-between">
            <h6 style="color: white">OEE</h6>
            <h6 style="color: white">{{ totaloee }} %</h6>
          </div>
        </div>
        <div class="card-body" style="height: 150px">
          <div *ngIf="!showload" echarts [options]="oeeOption" class="chart-container"
            style="width: 100%; min-height: 200px"></div>
          <div *ngIf="showload" class="d-flex flex-column align-items-center justify-content-center text-center">
            <ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="medium" color="rgba(0, 0, 0, 0.1)" type="ball-scale-multiple"
              [fullScreen]="false"></ngx-spinner>
            <span style="margin-top: 50px">Loading...!</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header" style="background-color: #0e7d79">
          <div style="display: flex; justify-content: space-between">
            <h6 style="color: white">Performance</h6>
            <h6 style="color: white">{{ totalperf }} %</h6>
          </div>
        </div>
        <div class="card-body" style="height: 150px">
          <div *ngIf="!showload" echarts [options]="performanceOption" class="chart-container"
            style="width: 100%; height: 200px"></div>
          <div *ngIf="showload" class="d-flex flex-column align-items-center justify-content-center text-center">
            <ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="medium" color="rgba(0, 0, 0, 0.1)" type="ball-scale-multiple"
              [fullScreen]="false"></ngx-spinner>
            <span style="margin-top: 50px">Loading...!</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="departmentData.length != 0">
    <div class="col-md-3">
      <div class="card">
        <div class="card-body text-center">
          <h6 style="font-size: 1.2rem">
            <b>{{ totalEnergy }} KwH</b>
          </h6>
          <h6>Total Energy</h6>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card">
        <div class="card-body text-center">
          <h6 style="font-size: 1.2rem">
            <b>₹ {{ energyCost }} </b>
          </h6>
          <h6>Energy Cost</h6>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card">
        <div class="card-body text-center">
          <h6 style="font-size: 1.2rem">
            <b>{{ aiPartCount }}</b>
          </h6>
          <h6>Part Count</h6>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card">
        <div class="card-body text-center">
          <h6 style="font-size: 1.2rem">
            <b>₹ {{ revenueLoss }}</b>
          </h6>
          <h6>Opportunity Cost</h6>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!showGraph">
    <div class="col-md-6 col-xl-4" *ngFor="let data of machine_List; trackBy: trackByDevice let i = index">
      <div class="card">
        <div class="card-body">
          <div class="spinner-grow m-1" role="status" [style.color]="statusColor(data.status)">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="row align-items-center d-flex justify-content-between">
            <div class="col-8">
              <h4 class="card-title mt-0 mb-1">{{ data.deviceName }}</h4>
              <div class="d-flex justify-content-between">
                <span>{{ data.deviceType ? data.deviceType : "-" }}</span>
                <span *ngIf="data.status == 3" class="text-danger font-weight-bold">INTERLOCK</span>
              </div>
            </div>

            <div class="col-4 d-flex justify-content-end">
              <div class="btn-group d-flex flex-nowrap" style="margin-top: -25px" ngbDropdown>
                <button class="btn btn-sm p-0 dropdown-toggle" type="button" ngbDropdownToggle aria-label="More Options"
                  title="Last Updated Time">
                  <i class="ri-compass-4-line font-size-24"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
                  <a class="dropdown-item" href="javascript:void(0);">
                    <span class="text-primary">(LUT)</span>
                    [ {{ epochToHHMMSS(data.LUT) }} ]
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="row" style="cursor: pointer" (click)="
              redirctTO(data.device_id, data.deviceName, data.deviceType)
            ">
            <div class="col-md-4 col-sm-4 d-flex d-md-block justify-content-between" style="margin: auto">
              <span data-bs-toggle="tooltip" data-bs-placement="top" style="cursor: pointer; white-space: nowrap">
                Partcount
              </span>
              <h4 *ngIf="data.config_type != 'no_part'">
                {{ data.Ai_partcount || 0 }}
              </h4>
              <h4 *ngIf="data.config_type == 'no_part'">NA</h4>
            </div>

            <div class="col-md-4 col-sm-4 d-flex d-md-block justify-content-between" style="margin: auto">
              M-Efficency
              <h4>
                {{ data.oee ? data.oee : 0 }}
                <span style="color: #007d79">% </span>
              </h4>
            </div>
            <div class="col-md-4 col-sm-4 d-flex d-md-block justify-content-between" style="margin: auto">
              T-Energy
              <h5 style="
                  display: inline-flex;
                  align-items: center;
                  white-space: nowrap;
                ">
                {{ data.total_energy ? data.total_energy : 0 }}
                <span style="color: #007d79; margin-left: 4px">KwH</span>
              </h5>
            </div>
          </div>
          <div class="row" (click)="
              redirctTO(data.device_id, data.deviceName, data.deviceType)
            " style="cursor: pointer !important">
            <div class="col-md-12 col-sm-12 d-flex justify-content-between">
              <div class="d-flex flex-column">
                <label class="fw-bold mb-0">Part Name</label>
                <span class="text-primary fw-bold">
                  <ng-container *ngIf="data.config_type != 'no_part'; else noPart">
                    {{ data.partName || "Not Planned" }}
                  </ng-container>
                  <ng-template #noPart>NA</ng-template>
                </span>
              </div>

              <div class="d-flex flex-column text-end">
                <label class="fw-bold mb-0">Energy Cost</label>
                <span class="fw-bold"> ₹ {{ data.powerUnitCost || "0" }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="showGraph">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <app-graphview></app-graphview>
        </div>
      </div>
    </div>
  </div>
</div>